import { Clients } from "../../types/enums";
import { LoanTypeForFields } from "../enums";
import { BRIDGE_V2_ID } from "./versions";

const bridgeV2 = {
  id: BRIDGE_V2_ID,
  [Clients.BPL_SIZER]: {
    inputFields: {
      borrowerInformation: [
        "propertiesCompletedWithinLast36Months",
        "foreignNational",
        "ImmigrationStatus",
        "originalCreditScore",
        "borrowerAddress",
      ],
      loanInformation: [
        "OriginatorLoanID",
        "LoanStructure",
        "LoanPurpose",
        "CashOutFlag",
        "ExitStrategy",
        "pledgeOfEquity",
      ],
      loanEconomics: [
        "InitialLoanAmount",
        "OrgInterestRate",
        "TotalRehabBudget",
        "financedBudget",
        "TotalOrgAndDiscountPoints",
      ],
      propertyLocation: ["address", "postalCode", "city", "state"],
      propertyInformation: [
        "propertyType",
        "ExpansionOrChangeOfUseCase",
        "ValuationSource",
        "PercentOccupied",
      ],
      propertyEconomics: [
        "orgAppraisalValue",
        "purchasePrice",
        "ClosingCost",
        "AsRepairedValueARV",
        "EstimatedRentPerYearUponCompletion",
        "costBasis",
        "AssignmentFee",
        "annualPropertyTaxes",
        "annualInsurance",
        "annualHOAFee",
      ],
      loanFeatures: ["OriginalAsIsLtv", "originalAsRepairedLTV", "OriginalLtc"],
      loanCharacterization: [
        "CustomerTypeExperiencedNew",
        "PurchaseOrRefinance",
        "rehabType",
        "StabilizedFlag",
        "loanCharacterization",
      ],
      propertyLoanFeatures: [
        "cbsa",
        "MedianValue",
        "LtmHpa",
        "DaysOnMarket",
        "ESRIPopulationDensity",
      ],
    },
    outputFields: {},
  },
  [Clients.MMTC]: {
    inputFields: {
      borrowerInformation: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "borrowerType",
          "propertiesCompletedWithinLast36Months",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          "originalCreditScore",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          // "borrowerAddress",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "borrowerType",
          "propertiesCompletedWithinLast36Months",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          "originalCreditScore",
          "borrowerAddress",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "borrowerType",
          "propertiesCompletedWithinLast36Months",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          "originalCreditScore",
          "borrowerAddress",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "borrowerType",
          "propertiesCompletedWithinLast36Months",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          "originalCreditScore",
          "borrowerAddress",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "borrowerType",
          "propertiesCompletedWithinLast36Months",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          "originalCreditScore",
          "borrowerAddress",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "borrowerType",
          "borrowerGUCExperience",
          "heavyRehabExperience",
          "originalCreditScore",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          "BorrowerGuarantor",
          "ImmigrationStatus",

          // "borrowerAddress",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "borrowerType",
          "borrowerGUCExperience",
          "heavyRehabExperience",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "originalCreditScore",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          // "borrowerAddress",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "borrowerType",
          "borrowerGUCExperience",
          "heavyRehabExperience",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "originalCreditScore",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          // "borrowerAddress",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "borrowerType",
          "borrowerGUCExperience",
          "heavyRehabExperience",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          "originalCreditScore",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          // "borrowerAddress",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "borrowerType",
          "borrowerGUCExperience",
          "heavyRehabExperience",
          "originalCreditScore",
          "borrowingEntityName",
          "borrowerName",
          "borrowerEmail",
          "guarantorName",
          "guarantorEmail",
          "BorrowerGuarantor",
          "ImmigrationStatus",
          // "borrowerAddress",
        ],
      },
      loanInformation: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "OriginatorLoanID",
          "LoanStructure",
          "FixFlipMFLoanPurpose",
          "CashOutFlag",
          "recourse",
          "ExitStrategy",
          "LoanTerm",
          "requiredInterestReserve",
          "requiredInterestReserveMonths",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "OriginatorLoanID",
          "LoanStructure",
          "FixFlipMFLoanPurpose",
          "CashOutFlag",
          "recourse",
          "ExitStrategy",
          "LoanTerm",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "OriginatorLoanID",
          "LoanStructure",
          "FixFlipMFLoanPurpose",
          "CashOutFlag",
          "recourse",
          "ExitStrategy",
          "LoanTerm",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "OriginatorLoanID",
          "LoanStructure",
          "FixFlipMFLoanPurpose",
          "CashOutFlag",
          "recourse",
          "ExitStrategy",
          "LoanTerm",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "OriginatorLoanID",
          "LoanStructure",
          "FixFlipMFLoanPurpose",
          "CashOutFlag",
          "recourse",
          "ExitStrategy",
          "LoanTerm",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "OriginatorLoanID",
          "LoanStructurev2",
          "CashOutFlag",
          "GRExitStrategy",
          "LoanTerm",
          "irFundingSource",
          "permitApprovalsAndFullPlans",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "OriginatorLoanID",
          "LoanStructurev2",
          "CashOutFlag",
          "GRExitStrategy",
          "LoanTerm",
          "irFundingSource",
          "permitApprovalsAndFullPlans",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "OriginatorLoanID",
          "LoanStructurev2",
          "CashOutFlag",
          "GRExitStrategy",
          "LoanTerm",
          "irFundingSource",
          "permitApprovalsAndFullPlans",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "OriginatorLoanID",
          "LoanStructurev2",
          "CashOutFlag",
          "GRExitStrategy",
          "LoanTerm",
          "irFundingSource",
          "permitApprovalsAndFullPlans",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "OriginatorLoanID",
          "LoanStructurev2",
          "CashOutFlag",
          "GRExitStrategy",
          "LoanTerm",
          "irFundingSource",
          "permitApprovalsAndFullPlans",
          "requiredInterestReserve",
          "requiredInterestReserveMonths",
        ],
      },
      loanEconomics: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "exitDebt",
          "hardCosts",
          "softCostsCap15Rehab",
          "TotalRehabBudget",
          "InitialLoanAmount",
          "TotalOrgAndDiscountPoints",
          "interestRate",
          "financedBudget",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "exitDebt",
          "hardCosts",
          "softCostsCap15Rehab",
          "InitialLoanAmount",
          "TotalOrgAndDiscountPoints",
          "interestRate",
          "financedBudget",
          "includeOutOfPocketBudgetARLTV",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "exitDebt",
          "hardCosts",
          "softCostsCap15Rehab",
          "InitialLoanAmount",
          "TotalOrgAndDiscountPoints",
          "interestRate",
          "financedBudget",
          "includeOutOfPocketBudgetARLTV",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "exitDebt",
          "hardCosts",
          "softCostsCap15Rehab",
          "InitialLoanAmount",
          "TotalOrgAndDiscountPoints",
          "interestRate",
          "financedBudget",
          "includeOutOfPocketBudgetARLTV",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "exitDebt",
          "hardCosts",
          "softCostsCap15Rehab",
          "InitialLoanAmount",
          "TotalOrgAndDiscountPoints",
          "interestRate",
          "financedBudget",
          "includeOutOfPocketBudgetARLTV",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "hardCosts",
          "softCosts",
          "InitialLoanAmount",
          "financedBudget",
          "InterestReserve",
          "orgBrokerFee",
          "interestRate",
          "totalBudget",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "hardCosts",
          "softCosts",
          "InitialLoanAmount",
          "financedBudget",
          "InterestReserve",
          "orgBrokerFee",
          "interestRate",
          "totalBudget",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "hardCosts",
          "softCosts",
          "InitialLoanAmount",
          "financedBudget",
          "InterestReserve",
          "orgBrokerFee",
          "interestRate",
          "totalBudget",
          "permitApprovalsAndFullPlans",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "hardCosts",
          "softCosts",
          "InitialLoanAmount",
          "financedBudget",
          "InterestReserve",
          "orgBrokerFee",
          "interestRate",
          "totalBudget",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "hardCosts",
          "softCosts",
          "InitialLoanAmount",
          "financedBudget",
          "InterestReserve",
          "orgBrokerFee",
          "interestRate",
          "totalBudget",
        ],
      },
      propertyLocation: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "address",
          "postalCode",
          "city",
          "state",
          "permitApprovalsAndFullPlans",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "address",
          "postalCode",
          "city",
          "state",
        ],
      },
      propertyInformation: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "mfPropertyType",
          "noOfUnits",
          "ExpansionOrChangeOfUseCase",
          "ValuationSource",
          "PercentOccupied",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "propertyType",
          "ExpansionOrChangeOfUseCase",
          "ValuationSource",
          "PercentOccupied",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "propertyType",
          "ExpansionOrChangeOfUseCase",
          "ValuationSource",
          "PercentOccupied",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "propertyType",
          "ExpansionOrChangeOfUseCase",
          "ValuationSource",
          "PercentOccupied",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "propertyType",
          "ExpansionOrChangeOfUseCase",
          "ValuationSource",
          "PercentOccupied",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "propertyType",
          "noOfUnits",
          "ValuationSource",
          "propertyPurchasedWithinLast2Years",
          "entitledAsOfRightDevelopment",
          "isPurchasedWithDebt",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "propertyType",
          "noOfUnits",
          "ValuationSource",
          "propertyPurchasedWithinLast2Years",
          "entitledAsOfRightDevelopment",
          "isPurchasedWithDebt",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "propertyType",
          "noOfUnits",
          "ValuationSource",
          "propertyPurchasedWithinLast2Years",
          "entitledAsOfRightDevelopment",
          "isPurchasedWithDebt",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "propertyType",
          "noOfUnits",
          "ValuationSource",
          "propertyPurchasedWithinLast2Years",
          "entitledAsOfRightDevelopment",
          "isPurchasedWithDebt",
          "state",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "mfPropertyType",
          "noOfUnits",
          "ValuationSource",
          "propertyPurchasedWithinLast2Years",
          "entitledAsOfRightDevelopment",
          "isPurchasedWithDebt",
        ],
      },
      propertyEconomics: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "orgAppraisalValue",
          "purchasePrice",
          "borrowerPaidCostToDate",
          "AsRepairedValueARV",
          "EstimatedRentPerYearUponCompletion",
          "appraisalStabilizedNOI",
          "annualPropertyTaxes",
          "costBasis",
          "grossCondoSelloutValue",
          "AssignmentFee",
          "purchaseDate",
          "annualInsurance",
          "annualHOAFee",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "orgAppraisalValue",
          "purchasePrice",
          "borrowerPaidCostToDate",
          "AsRepairedValueARV",
          "EstimatedRentPerYearUponCompletion",
          "appraisalStabilizedNOI",
          "annualPropertyTaxes",
          "costBasis",
          "grossCondoSelloutValue",
          "AssignmentFee",
          "purchaseDate",
          "annualInsurance",
          "annualHOAFee",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "orgAppraisalValue",
          "purchasePrice",
          "borrowerPaidCostToDate",
          "AsRepairedValueARV",
          "EstimatedRentPerYearUponCompletion",
          "appraisalStabilizedNOI",
          "annualPropertyTaxes",
          "costBasis",
          "grossCondoSelloutValue",
          "AssignmentFee",
          "purchaseDate",
          "annualInsurance",
          "annualHOAFee",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "orgAppraisalValue",
          "purchasePrice",
          "borrowerPaidCostToDate",
          "AsRepairedValueARV",
          "EstimatedRentPerYearUponCompletion",
          "appraisalStabilizedNOI",
          "annualPropertyTaxes",
          "costBasis",
          "grossCondoSelloutValue",
          "AssignmentFee",
          "purchaseDate",
          "annualInsurance",
          "annualHOAFee",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "orgAppraisalValue",
          "purchasePrice",
          "borrowerPaidCostToDate",
          "AsRepairedValueARV",
          "EstimatedRentPerYearUponCompletion",
          "appraisalStabilizedNOI",
          "annualPropertyTaxes",
          "costBasis",
          "grossCondoSelloutValue",
          "AssignmentFee",
          "purchaseDate",
          "annualInsurance",
          "annualHOAFee",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "asIsValue",
          "EstimatedRentPerYearUponCompletion",
          "purchasePrice",
          "ClosingCost",
          "afterRepairValue",
          "AssignmentFee",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "asIsValue",
          "EstimatedRentPerYearUponCompletion",
          "purchasePrice",
          "ClosingCost",
          "afterRepairValue",
          "AssignmentFee",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "asIsValue",
          "EstimatedRentPerYearUponCompletion",
          "purchasePrice",
          "ClosingCost",
          "afterRepairValue",
          "AssignmentFee",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "asIsValue",
          "EstimatedRentPerYearUponCompletion",
          "purchasePrice",
          "ClosingCost",
          "afterRepairValue",
          "AssignmentFee",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "asIsValue",
          "EstimatedRentPerYearUponCompletion",
          "purchasePrice",
          "ClosingCost",
          "afterRepairValue",
          "AssignmentFee",
        ],
      },
      loanFeatures: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "OriginalAsIsLtv",
          "originalAsRepairedLTV",
          "OriginalLtc",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "OriginalAsIsLtv",
          "originalAsRepairedLTV",
          "OriginalLtc",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "OriginalAsIsLtv",
          "originalAsRepairedLTV",
          "OriginalLtc",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "OriginalAsIsLtv",
          "originalAsRepairedLTV",
          "OriginalLtc",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "OriginalAsIsLtv",
          "originalAsRepairedLTV",
          "OriginalLtc",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "AsIsLTV",
          "LtcAsIs",
          "ARVLTVAsCompleted",
          "BlendedLTCAsCompleted",
          "BlendedLTCwithFundedIRAsCompleted",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "AsIsLTV",
          "LtcAsIs",
          "ARVLTVAsCompleted",
          "BlendedLTCAsCompleted",
          "BlendedLTCwithFundedIRAsCompleted",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "AsIsLTV",
          "LtcAsIs",
          "ARVLTVAsCompleted",
          "BlendedLTCAsCompleted",
          "BlendedLTCwithFundedIRAsCompleted",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "AsIsLTV",
          "LtcAsIs",
          "ARVLTVAsCompleted",
          "BlendedLTCAsCompleted",
          "BlendedLTCwithFundedIRAsCompleted",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "AsIsLTV",
          "LtcAsIs",
          "ARVLTVAsCompleted",
          "BlendedLTCAsCompleted",
          "BlendedLTCwithFundedIRAsCompleted",
        ],
      },
      loanCharacterisation: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "CustomerTypeExperiencedNew",
          "PurchaseOrRefinance",
          "rehabType",
          "StabilizedFlag",
          "loanCharacterization",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "CustomerTypeExperiencedNew",
          "PurchaseOrRefinance",
          "rehabType",
          "StabilizedFlag",
          "loanCharacterization",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "CustomerTypeExperiencedNew",
          "PurchaseOrRefinance",
          "rehabType",
          "StabilizedFlag",
          "loanCharacterization",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "CustomerTypeExperiencedNew",
          "PurchaseOrRefinance",
          "rehabType",
          "StabilizedFlag",
          "loanCharacterization",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "CustomerTypeExperiencedNew",
          "PurchaseOrRefinance",
          "rehabType",
          "StabilizedFlag",
          "loanCharacterization",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "loanCharacterization",
          "Tier",
          "LoanPurpose",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "loanCharacterization",
          "Tier",
          "LoanPurpose",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "loanCharacterization",
          "Tier",
          "LoanPurpose",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "loanCharacterization",
          "Tier",
          "LoanPurpose",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "loanCharacterization",
          "Tier",
          "LoanPurpose",
        ],
      },
      propLoanFeatures: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
        ],
        [LoanTypeForFields.FIXFLIP_SFR]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
        ],
        [LoanTypeForFields.FIXFLIP_UNIT_24]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
        ],
        [LoanTypeForFields.FIXFLIP_CONDO]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
        ],
        [LoanTypeForFields.FIXFLIP_TOWNHOME]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
        ],
        [LoanTypeForFields.GRUP_SFR]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
          "zipCodeDensity",
        ],
        [LoanTypeForFields.GRUP_UNIT_24]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
          "zipCodeDensity",
        ],
        [LoanTypeForFields.GRUP_CONDO]: [
          "OriginalAsIsLtv",
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
          "zipCodeDensity",
        ],
        [LoanTypeForFields.GRUP_TOWNHOME]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
          "zipCodeDensity",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "cbsa",
          "MedianValue",
          "LtmHpa",
          "DaysOnMarket",
          "zipCodeDensity",
        ],
      },
      marketData: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "MarketName",
          "CapRate",
          "TwelveMonthRentalGrowth",
          "RentPerSqFt",
          "RentPerUnit",
          "SalePriceGrowth",
          "SalePricePerUnit",
          "Population",
          "VacancyRate",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "MarketName",
          "CapRate",
          "TwelveMonthRentalGrowth",
          "RentPerSqFt",
          "RentPerUnit",
          "SalePriceGrowth",
          "SalePricePerUnit",
          "Population",
          "VacancyRate",
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
      subMarketData: {
        quickLoanSizing: [],
        [LoanTypeForFields.FIXFLIP_MULTIFAMILYMIXEDUSE]: [
          "SubMarketName",
          "CapRate",
          "TwelveMonthRentalGrowth",
          "RentPerSqFt",
          "RentPerUnit",
          "SalePriceGrowth",
          "SalePricePerUnit",
          "VacancyRate",
        ],
        [LoanTypeForFields.GRUP_MULTIFAMILYMIXEDUSE]: [
          "SubMarketName",
          "CapRate",
          "TwelveMonthRentalGrowth",
          "RentPerSqFt",
          "RentPerUnit",
          "SalePriceGrowth",
          "SalePricePerUnit",
          "VacancyRate",
        ],
        [LoanTypeForFields.SFR]: [],
        [LoanTypeForFields.UNIT_24]: [],
        [LoanTypeForFields.CONDO]: [],
        [LoanTypeForFields.TOWNHOME]: [],
      },
    },
    outputFields: {},
  },
};

export default bridgeV2;
